import apiClient from './client';

/** The plan One Manager set for the signed-in user's business (state, modules, limits, usage). */
export const hubPlanAPI = {
  get: async () => {
    const response = await apiClient.get('/hub-plan');
    return response.data;
  }
};
